import { useLocation, useNavigate } from "react-router-dom";

import Header from "./Header";

import { Button } from "@/components/ui/button";

// Catch-all page for unknown URLs. There is no shared layout route in this app —
// every page renders its own Header — so this page brings its own chrome too.
// The strings are plain German literals on purpose: the locale files are being
// refactored elsewhere and must not gain keys from here.
export default function NotFoundPage() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div className="flex h-dvh w-full flex-col">
            <Header showHome showSettings title="Seite nicht gefunden"></Header>
            <div className="flex flex-1 flex-col items-center justify-center bg-[var(--customer-primary-lighter)] p-8">
                <div className="text-5xl font-semibold">404</div>
                <p className="mt-4 text-sm">
                    Die Seite <span className="font-bold">{pathname}</span> gibt es nicht.
                </p>
                <Button type="button" className="mt-4" onClick={() => navigate("/chatbot")}>
                    Zum Assistenten
                </Button>
            </div>
        </div>
    );
}
